import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';

interface RedirectPreservingQueryProps {
    to: string;
    push?: boolean;
}

const RedirectPreservingUTMQuery: React.FC<RedirectPreservingQueryProps> = ({ to, push = false }) => {
    const location = useLocation();

    const searchParams = new URLSearchParams(location.search);
    const preservedParams = new URLSearchParams();

    const paramsToPreserve = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'first_source', '_gl', '_ga'];

    paramsToPreserve.forEach(param => {
        const value = searchParams.get(param);
        if (value) {
            preservedParams.set(param, value);
        }
    });

    const queryString = preservedParams.toString();
    const destination = {
        pathname: to,
        search: queryString ? `?${queryString}` : '',
    };

    return <Redirect to={destination} push={push} />;
};

export default RedirectPreservingUTMQuery;
